import styled from "styled-components";

export const SellingPlanWrapper = styled.div<{ isMobile: boolean }>`
  width: 100%;

  > div {
    width: ${({ isMobile }) => (isMobile ? "100%" : "50%")};
  }
`;
